export const huboList = [
  {
    huboid: '100138381',
    giho: 1,
    name: '이재명',
    jd_name: '더불어민주당',
    color: '#3F69FF',
    slogan: '위기에 강한\n유능한 경제 대통령',
    report:
      'http://elecinfo.nec.go.kr/neweps/viewPdf.do?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303031532E706466&ctl_no_id=ECM01202200010001&epdata_id=ECM101',
  },
  {
    huboid: '100138362',
    giho: 2,
    name: '윤석열',
    jd_name: '국민의힘',
    color: '#E61E2B',
    slogan: '국민이 키운 윤석열\n내일을 바꾸는 대통령',
    report:
      'http://elecinfo.nec.go.kr/neweps/viewPdf.do?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303032532E706466&ctl_no_id=ECM01202200010002&epdata_id=ECM101',
  },
  {
    huboid: '100138383',
    giho: 3,
    name: '심상정',
    jd_name: '정의당',
    color: '#f5e730',
    slogan: '노동의 희망\n시민의 꿈',
    report:
      'http://elecinfo.nec.go.kr/neweps/viewPdf.do?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303033532E706466&ctl_no_id=ECM01202200010003&epdata_id=ECM101',
  },
  {
    huboid: '100138395',
    giho: 5,
    name: '오준호',
    jd_name: '기본소득당',
    color: '#19233C',
    slogan: '누구나 기본소득\n나답게 대한민국',
    report:
      'http://elecinfo.nec.go.kr/neweps/ezpdfwebviewer/ezpdf/customLayout.jsp?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303034532E706466',
  },
  {
    huboid: '100138378',
    giho: 6,
    name: '허경영',
    jd_name: '국가혁명당',
    color: '#DB2C2B',
    slogan: '국민 배당금 지급!\n가계부채 탕감!',
    report:
      'http://elecinfo.nec.go.kr/neweps/viewPdf.do?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303035532E706466&ctl_no_id=ECM01202200010005&epdata_id=ECM101',
  },
  {
    huboid: '100138411',
    giho: 7,
    name: '이백윤',
    jd_name: '노동당',
    color: '#FF0000',
    slogan: '계속 이렇게 살거야?\n바꾸고 싶다면 사회주의',
    report:
      'http://elecinfo.nec.go.kr/neweps/viewPdf.do?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303036532E706466&ctl_no_id=ECM01202200010006&epdata_id=ECM101',
  },
  {
    huboid: '100138489',
    giho: 8,
    name: '옥은호',
    jd_name: '새누리당',
    color: '#C9252B',
    slogan: '부정선거 단죄 못하면\n망국의 길로 갑니다’',
    report:
      'http://elecinfo.nec.go.kr/neweps/viewPdf.do?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303037532E706466&ctl_no_id=ECM01202200010007&epdata_id=ECM101',
  },
  {
    huboid: '100138380',
    giho: 10,
    name: '김경재',
    jd_name: '신자유민주연합',
    color: '#AD469F',
    slogan: '박근혜 대통령\n 명예회복 민생안정',
    report:
      'http://elecinfo.nec.go.kr/neweps/viewPdf.do?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303038532E706466&ctl_no_id=ECM01202200010008&epdata_id=ECM101',
  },
  {
    huboid: '100138379',
    giho: 11,
    name: '조원진',
    jd_name: '우리공화당',
    color: '#009944',
    slogan: '국민여러분 힘내세요!\n쓰레기 정치 확!',
    report:
      'http://elecinfo.nec.go.kr/neweps/viewPdf.do?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303039532E706466&ctl_no_id=ECM01202200010009&epdata_id=ECM101',
  },
  {
    huboid: '100138375',
    giho: 12,
    name: '김재연',
    jd_name: '진보당',
    color: '#D6001C',
    slogan: '당신의 땀이 빛나도록\n일하는 사람들의 정치혁명',
    report:
      'http://elecinfo.nec.go.kr/neweps/viewPdf.do?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303130532E706466&ctl_no_id=ECM01202200010010&epdata_id=ECM101',
  },
  {
    huboid: '100138531',
    giho: 13,
    name: '이경희',
    jd_name: '통일한국당',
    color: '#003793',
    slogan: '오직 경제, 오직 통일!\n청년사업가, 법학박사',
    report:
      'http://elecinfo.nec.go.kr/neweps/viewPdf.do?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303131532E706466&ctl_no_id=ECM01202200010011&epdata_id=ECM101',
  },
  {
    huboid: '100138402',
    giho: 14,
    name: '김민찬',
    jd_name: '한류연합당',
    color: '#733A87',
    slogan: '국가를 지키고\n국민을 보호하겠습니다',
    report:
      'http://elecinfo.nec.go.kr/neweps/viewPdf.do?contentId=2F6570646174612F455032322F45434D323032322F30312F45434D303132303232303030312F45434D303132303232303030315F30303132532E706466&ctl_no_id=ECM01202200010012&epdata_id=ECM101',
  },
];
